import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Languages, Award } from "lucide-react";
import { api } from "@/lib/api";
import { photoSrc } from "@/components/Reviews";

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-+$/, "");

export default function Team() {
  const [team, setTeam] = useState([]);
  useEffect(() => { api.get("/team").then((r) => setTeam(r.data)).catch(() => {}); }, []);
  if (team.length === 0) return null;
  return (
    <section id="team" className="py-20 lg:py-28 bg-white" data-testid="team-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.8 }} className="max-w-2xl mb-10">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-terra mb-3">The People</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-ink">Who's <span className="italic text-terra">picking you up</span></h2>
          <p className="mt-4 text-ink/70 leading-relaxed">Real faces, real riders. Every driver and guide at Random Rider is verified, local and knows Puri's stories by heart.</p>
        </motion.div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {team.map((m, i) => (
            <motion.div key={m.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }} transition={{ duration: 0.6, delay: (i % 4) * 0.08 }} whileHover={{ y: -6 }}
              className="bg-white rounded-2xl overflow-hidden border border-ink/10 hover:shadow-xl hover:shadow-ink/10 transition-shadow duration-500" data-testid={`team-card-${slugify(m.name)}`}>
              <div className="aspect-[4/5] overflow-hidden bg-sand">
                {m.photo_url ? <img src={photoSrc(m.photo_url)} alt={m.name} loading="lazy" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center font-serif text-5xl text-ink/20">{m.name[0]}</div>}
              </div>
              <div className="p-4">
                <p className="font-mono text-[10px] uppercase tracking-widest text-terra">{m.role}</p>
                <h3 className="font-serif text-lg font-bold text-ink leading-snug mt-0.5">{m.name}</h3>
                {m.bio && <p className="text-xs text-ink/70 mt-2 leading-relaxed">{m.bio}</p>}
                <div className="mt-3 flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-ink/50">
                  {m.years > 0 && <span className="flex items-center gap-1"><Award size={11} /> {m.years} yrs</span>}
                  {m.languages && <span className="flex items-center gap-1"><Languages size={11} /> {m.languages}</span>}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
